<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3.75" y="3.75" width="22.5" height="22.5" rx="4.25" stroke="black" stroke-width="1.5"/>
<circle cx="10" cy="10" r="2" fill="black"/>
<circle cx="20" cy="10" r="2" fill="black"/>
<circle cx="15" cy="15" r="2" fill="black"/>
<circle cx="10" cy="20" r="2" fill="black"/>
<circle cx="20" cy="20" r="2" fill="black"/>
</svg>
